/* ================================================== */
/* SHARE → Twitter
/* ================================================== */

$(document).ready(function(){

	$.ajaxSetup({ cache: true });
	$.getScript('//platform.twitter.com/widgets.js');

});